<div
  class="tooltip-host"
  [class.tooltip-disabled]="disabled"
  [class.tooltip-full-width]="fullWidth"
>
  <div class="tooltip-trigger" [attr.aria-label]="title">
    <ng-content></ng-content>
  </div>

  <div class="tooltip_3310-20057" role="tooltip" aria-live="polite">
    <div class="container_I3310-20057-3310-18265">
      <div class="container_I3310-20057-3310-18266">
        <div class="icon_I3310-20057-3310-18267">
          <img src="assets/images/tooltiptime.svg" alt="" />
        </div>
      </div>
      <div class="text_I3310-20057-3310-18270">
        <span class="text-coming-soon_I3310-20057-3310-18271">{{ title }}</span>
        <span class="text-feature-in-development_I3310-20057-3310-18272">{{ description }}</span>
      </div>
    </div>
    <div class="polygon-1_I3310-20057-3310-18273" aria-hidden="true"></div>
    <div class="image-5_I3310-20057-3310-18829" aria-hidden="true">
    </div>
  </div>
</div>
